const tableJarvis = {
    wheelCircumference: 2095,
    brake: [
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 0},
        {speed: 16.8, power: 0},
        {speed: 18.7, power: 0},
        {speed: 20.6, power: 0},
        {speed: 22.4, power: 0},
        {speed: 24.4, power: 0},
        {speed: 25.9, power: 0},
        {speed: 27.6, power: 0},
        {speed: 29.8, power: 0},
        {speed: 31.4, power: 0},
        {speed: 33.2, power: 0},
        {speed: 35.2, power: 0},
        {speed: 36.9, power: 0},
        {speed: 40.7, power: 0},
        {speed: 44.5, power: 0},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 22},
        {speed: 16.8, power: 28},
        {speed: 18.7, power: 32},
        {speed: 20.6, power: 36},
        {speed: 22.4, power: 41},
        {speed: 24.4, power: 48},
        {speed: 25.9, power: 49},
        {speed: 27.6, power: 53},
        {speed: 29.8, power: 59},
        {speed: 31.4, power: 62},
        {speed: 33.2, power: 69},
        {speed: 35.2, power: 71},
        {speed: 36.9, power: 76},
        {speed: 40.7, power: 88},
        {speed: 44.5, power: 97},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 23},
        {speed: 16.8, power: 29},
        {speed: 18.7, power: 32},
        {speed: 20.6, power: 37},
        {speed: 22.4, power: 42},
        {speed: 24.4, power: 50},
        {speed: 25.9, power: 51},
        {speed: 27.6, power: 56},
        {speed: 29.8, power: 62},
        {speed: 31.4, power: 66},
        {speed: 33.2, power: 73},
        {speed: 35.2, power: 75},
        {speed: 36.9, power: 82},
        {speed: 40.7, power: 91},
        {speed: 44.5, power: 99},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 25},
        {speed: 16.8, power: 30},
        {speed: 18.7, power: 35},
        {speed: 20.6, power: 41},
        {speed: 22.4, power: 46},
        {speed: 24.4, power: 54},
        {speed: 25.9, power: 56},
        {speed: 27.6, power: 61},
        {speed: 29.8, power: 68},
        {speed: 31.4, power: 74},
        {speed: 33.2, power: 80},
        {speed: 35.2, power: 84},
        {speed: 36.9, power: 86},
        {speed: 40.7, power: 103},
        {speed: 44.5, power: 116},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 27},
        {speed: 16.8, power: 33},
        {speed: 18.7, power: 38},
        {speed: 20.6, power: 44},
        {speed: 22.4, power: 51},
        {speed: 24.4, power: 58},
        {speed: 25.9, power: 60},
        {speed: 27.6, power: 67},
        {speed: 29.8, power: 75},
        {speed: 31.4, power: 79},
        {speed: 33.2, power: 88},
        {speed: 35.2, power: 91},
        {speed: 36.9, power: 98},
        {speed: 40.7, power: 114},
        {speed: 44.5, power: 121},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 29},
        {speed: 16.8, power: 36},
        {speed: 18.7, power: 42},
        {speed: 20.6, power: 49},
        {speed: 22.4, power: 56},
        {speed: 24.4, power: 65},
        {speed: 25.9, power: 68},
        {speed: 27.6, power: 75},
        {speed: 29.8, power: 84},
        {speed: 31.4, power: 89},
        {speed: 33.2, power: 98},
        {speed: 35.2, power: 104},
        {speed: 36.9, power: 110},
        {speed: 40.7, power: 124},
        {speed: 44.5, power: 134},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 31},
        {speed: 16.8, power: 41},
        {speed: 18.7, power: 47},
        {speed: 20.6, power: 55},
        {speed: 22.4, power: 63},
        {speed: 24.4, power: 72},
        {speed: 25.9, power: 76},
        {speed: 27.6, power: 85},
        {speed: 29.8, power: 95},
        {speed: 31.4, power: 101},
        {speed: 33.2, power: 111},
        {speed: 35.2, power: 115},
        {speed: 36.9, power: 125},
        {speed: 40.7, power: 140},
        {speed: 44.5, power: 159},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 35},
        {speed: 16.8, power: 45},
        {speed: 18.7, power: 53},
        {speed: 20.6, power: 63},
        {speed: 22.4, power: 70},
        {speed: 24.4, power: 82},
        {speed: 25.9, power: 86},
        {speed: 27.6, power: 95},
        {speed: 29.8, power: 106},
        {speed: 31.4, power: 113},
        {speed: 33.2, power: 127},
        {speed: 35.2, power: 133},
        {speed: 36.9, power: 141},
        {speed: 40.7, power: 158},
        {speed: 44.5, power: 173},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 40},
        {speed: 16.8, power: 50},
        {speed: 18.7, power: 59},
        {speed: 20.6, power: 70},
        {speed: 22.4, power: 79},
        {speed: 24.4, power: 91},
        {speed: 25.9, power: 96},
        {speed: 27.6, power: 105},
        {speed: 29.8, power: 120},
        {speed: 31.4, power: 128},
        {speed: 33.2, power: 139},
        {speed: 35.2, power: 146},
        {speed: 36.9, power: 157},
        {speed: 40.7, power: 177},
        {speed: 44.5, power: 199},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 44},
        {speed: 16.8, power: 57},
        {speed: 18.7, power: 66},
        {speed: 20.6, power: 78},
        {speed: 22.4, power: 89},
        {speed: 24.4, power: 102},
        {speed: 25.9, power: 108},
        {speed: 27.6, power: 120},
        {speed: 29.8, power: 134},
        {speed: 31.4, power: 145},
        {speed: 33.2, power: 155},
        {speed: 35.2, power: 165},
        {speed: 36.9, power: 181},
        {speed: 40.7, power: 200},
        {speed: 44.5, power: 227},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 50},
        {speed: 16.8, power: 63},
        {speed: 18.7, power: 74},
        {speed: 20.6, power: 87},
        {speed: 22.4, power: 99},
        {speed: 24.4, power: 113},
        {speed: 25.9, power: 121},
        {speed: 27.6, power: 134},
        {speed: 29.8, power: 149},
        {speed: 31.4, power: 161},
        {speed: 33.2, power: 176},
        {speed: 35.2, power: 187},
        {speed: 36.9, power: 199},
        {speed: 40.7, power: 221},
        {speed: 44.5, power: 249},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 57},
        {speed: 16.8, power: 71},
        {speed: 18.7, power: 83},
        {speed: 20.6, power: 98},
        {speed: 22.4, power: 111},
        {speed: 24.4, power: 127},
        {speed: 25.9, power: 138},
        {speed: 27.6, power: 152},
        {speed: 29.8, power: 170},
        {speed: 31.4, power: 179},
        {speed: 33.2, power: 196},
        {speed: 35.2, power: 208},
        {speed: 36.9, power: 225},
        {speed: 40.7, power: 251},
        {speed: 44.5, power: 276},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 64},
        {speed: 16.8, power: 80},
        {speed: 18.7, power: 92},
        {speed: 20.6, power: 110},
        {speed: 22.4, power: 124},
        {speed: 24.4, power: 143},
        {speed: 25.9, power: 154},
        {speed: 27.6, power: 168},
        {speed: 29.8, power: 189},
        {speed: 31.4, power: 200},
        {speed: 33.2, power: 216},
        {speed: 35.2, power: 230},
        {speed: 36.9, power: 246},
        {speed: 40.7, power: 280},
        {speed: 44.5, power: 308},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 70},
        {speed: 16.8, power: 86},
        {speed: 18.7, power: 102},
        {speed: 20.6, power: 120},
        {speed: 22.4, power: 135},
        {speed: 24.4, power: 156},
        {speed: 25.9, power: 168},
        {speed: 27.6, power: 183},
        {speed: 29.8, power: 205},
        {speed: 31.4, power: 220},
        {speed: 33.2, power: 240},
        {speed: 35.2, power: 249},
        {speed: 36.9, power: 267},
        {speed: 40.7, power: 302},
        {speed: 44.5, power: 330},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 78},
        {speed: 16.8, power: 95},
        {speed: 18.7, power: 112},
        {speed: 20.6, power: 132},
        {speed: 22.4, power: 150},
        {speed: 24.4, power: 172},
        {speed: 25.9, power: 185},
        {speed: 27.6, power: 203},
        {speed: 29.8, power: 225},
        {speed: 31.4, power: 241},
        {speed: 33.2, power: 260},
        {speed: 35.2, power: 276},
        {speed: 36.9, power: 295},
        {speed: 40.7, power: 335},
        {speed: 44.5, power: 366},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 86},
        {speed: 16.8, power: 108},
        {speed: 18.7, power: 124},
        {speed: 20.6, power: 144},
        {speed: 22.4, power: 164},
        {speed: 24.4, power: 189},
        {speed: 25.9, power: 203},
        {speed: 27.6, power: 221},
        {speed: 29.8, power: 245},
        {speed: 31.4, power: 260},
        {speed: 33.2, power: 284},
        {speed: 35.2, power: 298},
        {speed: 36.9, power: 320},
        {speed: 40.7, power: 360},
        {speed: 44.5, power: 395},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 92},
        {speed: 16.8, power: 113},
        {speed: 18.7, power: 133},
        {speed: 20.6, power: 155},
        {speed: 22.4, power: 177},
        {speed: 24.4, power: 201},
        {speed: 25.9, power: 218},
        {speed: 27.6, power: 238},
        {speed: 29.8, power: 264},
        {speed: 31.4, power: 283},
        {speed: 33.2, power: 306},
        {speed: 35.2, power: 324},
        {speed: 36.9, power: 346},
        {speed: 40.7, power: 387},
        {speed: 44.5, power: 428},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 101},
        {speed: 16.8, power: 122},
        {speed: 18.7, power: 143},
        {speed: 20.6, power: 169},
        {speed: 22.4, power: 190},
        {speed: 24.4, power: 218},
        {speed: 25.9, power: 236},
        {speed: 27.6, power: 258},
        {speed: 29.8, power: 283},
        {speed: 31.4, power: 304},
        {speed: 33.2, power: 329},
        {speed: 35.2, power: 351},
        {speed: 36.9, power: 374},
        {speed: 40.7, power: 418},
        {speed: 44.5, power: 460},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 109},
        {speed: 16.8, power: 131},
        {speed: 18.7, power: 156},
        {speed: 20.6, power: 181},
        {speed: 22.4, power: 206},
        {speed: 24.4, power: 236},
        {speed: 25.9, power: 255},
        {speed: 27.6, power: 276},
        {speed: 29.8, power: 306},
        {speed: 31.4, power: 334},
        {speed: 33.2, power: 352},
        {speed: 35.2, power: 375},
        {speed: 36.9, power: 399},
        {speed: 40.7, power: 443},
        {speed: 44.5, power: 490},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 117},
        {speed: 16.8, power: 141},
        {speed: 18.7, power: 166},
        {speed: 20.6, power: 195},
        {speed: 22.4, power: 220},
        {speed: 24.4, power: 252},
        {speed: 25.9, power: 272},
        {speed: 27.6, power: 296},
        {speed: 29.8, power: 327},
        {speed: 31.4, power: 351},
        {speed: 33.2, power: 378},
        {speed: 35.2, power: 403},
        {speed: 36.9, power: 427},
        {speed: 40.7, power: 476},
        {speed: 44.5, power: 521},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 125},
        {speed: 16.8, power: 150},
        {speed: 18.7, power: 176},
        {speed: 20.6, power: 207},
        {speed: 22.4, power: 236},
        {speed: 24.4, power: 270},
        {speed: 25.9, power: 291},
        {speed: 27.6, power: 314},
        {speed: 29.8, power: 348},
        {speed: 31.4, power: 373},
        {speed: 33.2, power: 399},
        {speed: 35.2, power: 430},
        {speed: 36.9, power: 452},
        {speed: 40.7, power: 506},
        {speed: 44.5, power: 552},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 134},
        {speed: 16.8, power: 162},
        {speed: 18.7, power: 190},
        {speed: 20.6, power: 223},
        {speed: 22.4, power: 251},
        {speed: 24.4, power: 290},
        {speed: 25.9, power: 312},
        {speed: 27.6, power: 339},
        {speed: 29.8, power: 374},
        {speed: 31.4, power: 402},
        {speed: 33.2, power: 433},
        {speed: 35.2, power: 469},
        {speed: 36.9, power: 483},
        {speed: 40.7, power: 544},
        {speed: 44.5, power: 594},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 143},
        {speed: 16.8, power: 175},
        {speed: 18.7, power: 205},
        {speed: 20.6, power: 237},
        {speed: 22.4, power: 269},
        {speed: 24.4, power: 309},
        {speed: 25.9, power: 336},
        {speed: 27.6, power: 363},
        {speed: 29.8, power: 403},
        {speed: 31.4, power: 430},
        {speed: 33.2, power: 461},
        {speed: 35.2, power: 492},
        {speed: 36.9, power: 519},
        {speed: 40.7, power: 578},
        {speed: 44.5, power: 637},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 154},
        {speed: 16.8, power: 187},
        {speed: 18.7, power: 220},
        {speed: 20.6, power: 256},
        {speed: 22.4, power: 290},
        {speed: 24.4, power: 333},
        {speed: 25.9, power: 360},
        {speed: 27.6, power: 392},
        {speed: 29.8, power: 433},
        {speed: 31.4, power: 462},
        {speed: 33.2, power: 493},
        {speed: 35.2, power: 533},
        {speed: 36.9, power: 561},
        {speed: 40.7, power: 630},
        {speed: 44.5, power: 689},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 168},
        {speed: 16.8, power: 202},
        {speed: 18.7, power: 237},
        {speed: 20.6, power: 277},
        {speed: 22.4, power: 313},
        {speed: 24.4, power: 360},
        {speed: 25.9, power: 389},
        {speed: 27.6, power: 423},
        {speed: 29.8, power: 466},
        {speed: 31.4, power: 499},
        {speed: 33.2, power: 536},
        {speed: 35.2, power: 577},
        {speed: 36.9, power: 603},
        {speed: 40.7, power: 677},
        {speed: 44.5, power: 745},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 183},
        {speed: 16.8, power: 220},
        {speed: 18.7, power: 258},
        {speed: 20.6, power: 301},
        {speed: 22.4, power: 343},
        {speed: 24.4, power: 395},
        {speed: 25.9, power: 427},
        {speed: 27.6, power: 463},
        {speed: 29.8, power: 508},
        {speed: 31.4, power: 546},
        {speed: 33.2, power: 587},
        {speed: 35.2, power: 628},
        {speed: 36.9, power: 661},
        {speed: 40.7, power: 735},
        {speed: 44.5, power: 809},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 201},
        {speed: 16.8, power: 239},
        {speed: 18.7, power: 284},
        {speed: 20.6, power: 332},
        {speed: 22.4, power: 375},
        {speed: 24.4, power: 436},
        {speed: 25.9, power: 469},
        {speed: 27.6, power: 508},
        {speed: 29.8, power: 557},
        {speed: 31.4, power: 597},
        {speed: 33.2, power: 643},
        {speed: 35.2, power: 689},
        {speed: 36.9, power: 731},
        {speed: 40.7, power: 808},
        {speed: 44.5, power: 891},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 222},
        {speed: 16.8, power: 266},
        {speed: 18.7, power: 311},
        {speed: 20.6, power: 364},
        {speed: 22.4, power: 411},
        {speed: 24.4, power: 480},
        {speed: 25.9, power: 517},
        {speed: 27.6, power: 560},
        {speed: 29.8, power: 614},
        {speed: 31.4, power: 655},
        {speed: 33.2, power: 705},
        {speed: 35.2, power: 759},
        {speed: 36.9, power: 806},
        {speed: 40.7, power: 891},
        {speed: 44.5, power: 975},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 243},
        {speed: 16.8, power: 290},
        {speed: 18.7, power: 343},
        {speed: 20.6, power: 396},
        {speed: 22.4, power: 450},
        {speed: 24.4, power: 527},
        {speed: 25.9, power: 567},
        {speed: 27.6, power: 615},
        {speed: 29.8, power: 674},
        {speed: 31.4, power: 718},
        {speed: 33.2, power: 771},
        {speed: 35.2, power: 828},
        {speed: 36.9, power: 882},
        {speed: 40.7, power: 976},
        {speed: 44.5, power: 1068},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 267},
        {speed: 16.8, power: 316},
        {speed: 18.7, power: 373},
        {speed: 20.6, power: 433},
        {speed: 22.4, power: 492},
        {speed: 24.4, power: 576},
        {speed: 25.9, power: 619},
        {speed: 27.6, power: 673},
        {speed: 29.8, power: 734},
        {speed: 31.4, power: 784},
        {speed: 33.2, power: 837},
        {speed: 35.2, power: 899},
        {speed: 36.9, power: 959},
        {speed: 40.7, power: 1079},
        {speed: 44.5, power: 1157},
      ],
      [
        {speed: 0.0, power: 0},
        {speed: 14.9, power: 285},
        {speed: 16.8, power: 338},
        {speed: 18.7, power: 396},
        {speed: 20.6, power: 458},
        {speed: 22.4, power: 519},
        {speed: 24.4, power: 611},
        {speed: 25.9, power: 657},
        {speed: 27.6, power: 712},
        {speed: 29.8, power: 779},
        {speed: 31.4, power: 829},
        {speed: 33.2, power: 889},
        {speed: 35.2, power: 952},
        {speed: 36.9, power: 1010},
        {speed: 40.7, power: 1138},
        {speed: 44.5, power: 1222},
      ],
    ],
};

export const ruote = [
  {id: 1,bici: 'gravel',tipo: '700x32C', sviluppo: 2126},
  {id: 2,bici: 'gravel',tipo: '700x35C', sviluppo: 2145},
  {id: 3,bici: 'gravel',tipo: '700x40C', sviluppo: 2189},
  {id: 4,bici: 'gravel',tipo: '700x45C', sviluppo: 2209},
  {id: 5,bici: 'gravel',tipo: '700x47C', sviluppo: 2220},
  {id: 6,bici: 'gravel',tipo: '700x50C', sviluppo: 2231},
  {id: 7,bici: 'gravel',tipo: '27,5x2,1', sviluppo: 2115},
  {id: 8,bici: 'gravel',tipo: '27,5x2,2', sviluppo: 2124},
  {id: 9, bici: 'mtb',tipo: '29x2,1', sviluppo: 2274},
  {id: 10,bici: 'mtb',tipo: '29x2,2', sviluppo: 2282},
  {id: 11,bici: 'mtb',tipo: '29x2,225', sviluppo: 2313},
  {id: 12,bici: 'mtb',tipo: '29x2,40', sviluppo: 2335},
  {id: 13,bici: 'mtb',tipo: '29x2,50', sviluppo: 2353},
  {id: 14,bici: 'mtb',tipo: '29x2,60', sviluppo: 2369},
  {id: 15,bici: 'mtb',tipo: '27,5x2,25', sviluppo: 2194},
  {id: 16,bici: 'mtb',tipo: '27,5x2,60', sviluppo: 2250},

]

  export const getJarvisWheelCircumference = () => {
    return tableJarvis.wheelCircumference;
  }
  
  export const getJarvisBrakeArray = () => {
    return tableJarvis.brake;
  }

  export const calcSpeedByRpmSprocketsWheelCircumference = (rpm,rapporto,circumference,binary) => {

    return (rpm / 60) * ((((rapporto)) * circumference) / 1000);
    
  };

  export const calcPowerByBrakeAndSpeed = (arr,speed,) => {
    const elPos = arr.findIndex(e => e.speed > speed);
    const startFrom = elPos === -1 ? arr.length - 2 : Math.max(0, elPos - 1);
    const before = arr[startFrom];
    const after = arr[startFrom + 1];
    return (
      before.power +
      ((after.power - before.power) / (after.speed - before.speed)) *
        (speed - before.speed)
    );
  };

export const calcPowerByBrakeNumberRpmFrontRear = (rpm, brake, front, rear) => {
    
  const msToKmh = (speedMs) => (speedMs * 3600) / 1000;
  
  const arr = getJarvisBrakeArray();
  const speed = calcSpeedByRpmSprocketsWheelCircumference(rpm,front,rear,2095);

  return calcPowerByBrakeAndSpeed(arr[brake],msToKmh(speed));

}

export const calcNewton = (watt, rpm) => {
    if (rpm <= 0) {
      return 0;
    }
    return (watt * 60) / (2 * Math.PI * rpm);
  };



/* export {calcPowerByBrakeNumberRpmFrontRear, calcNewton} */